import { useQuery } from "@tanstack/react-query";
import ApiService from "../../services/ApiService";
import { QUERY_KEYS } from "../keys";

export const useFacebookPageSearch = (query, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.FACEBOOK_PAGE_SEARCH, query],
    queryFn: async () => {
      if (!query || query.trim().length === 0) {
        return { data: [] };
      }
      const response = await ApiService.searchFacebookPages(query);
      return response.data;
    },
    enabled: !!query && query.trim().length > 0,
    staleTime: 1000 * 30, // 30 seconds - shorter for development
    cacheTime: 1000 * 60 * 2, // 2 minutes
    retry: false, // Don't retry failed requests
    ...options,
  });
};

export default useFacebookPageSearch;
